import React from 'react';
import './styles.css';
import { HeaderNavigation } from './components/HeaderNavigation';
import { HeaderButtonsBlock } from './components/HeaderButtonsBlock';
import { HeaderLogo } from './components/HeaderLogo';

export const HeaderInner = React.memo(() => {
  // проверка роута для промо баннера catch-game
  // const isAvailableToShowGameBanner = useCheckGameBannerAvailable();
  return (
    <div className="header-inner gap-2 relative">
      <HeaderNavigation />
      <HeaderLogo />
      <HeaderButtonsBlock />

      {/* промо баннер для catch-game
       {isDekstopLayout && isAvailableToShowGameBanner && (
        <PromoGameBanner className="absolute right-3 top-[76px]" isDesktopBanner />
      )} */}
    </div>
  );
});

HeaderInner.displayName = 'HeaderInner';
